import { Tag } from 'antd';

const AttendanceStatus = ({ status }) => {
  const getColor = () => {
    switch (status?.toLowerCase()) {
      case 'completed':
        return 'green';
      case 'absent':
        return 'red';
      default:
        return 'default';
    }
  };

  const getText = () => {
    if (!status) return 'N/A';
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  };

  return (
    <Tag color={getColor()} style={{ fontWeight: 'bold', borderRadius: '4px' }}>
      {getText()}
    </Tag>
  );
};

export default AttendanceStatus;
